import React from 'react';
import type { EvaluationLevelDisplayLabels, EvaluationLevelStepCount } from '../../types/evaluationPlan';
import { EVALUATION_LEVEL_LABELS, getActiveLevelLabelKeys } from '../../types/evaluationPlan';

const EvaluationPlanLevelLabelFields: React.FC<{
  levelStep: EvaluationLevelStepCount;
  displayLabels: EvaluationLevelDisplayLabels;
  onDisplayLabelsChange: (value: EvaluationLevelDisplayLabels) => void;
}> = ({ levelStep, displayLabels, onDisplayLabelsChange }) => {
  const activeLabelKeys = getActiveLevelLabelKeys(levelStep);

  return (
    <div className="cp-evaluation-plan-category-level-label-fields">
      <span className="cp-evaluation-plan-category-level-label-fields-title">단계별 표시 텍스트</span>
      <div
        className="cp-evaluation-plan-category-level-label-fields-grid"
        role="group"
        aria-label={`${levelStep}단계 성취수준 표시 텍스트`}
      >
        {activeLabelKeys.map((labelKey, idx) => {
          const letter = EVALUATION_LEVEL_LABELS[idx].toLowerCase();
          return (
            <label key={labelKey} className="cp-evaluation-plan-field cp-evaluation-plan-category-level-label-field">
              <span>{letter}</span>
              <input
                type="text"
                value={displayLabels[labelKey]}
                placeholder={EVALUATION_LEVEL_LABELS[idx]}
                onChange={(e) => onDisplayLabelsChange({ ...displayLabels, [labelKey]: e.target.value })}
                aria-label={`${levelStep}단계 성취수준 ${EVALUATION_LEVEL_LABELS[idx]} 표시 텍스트`}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default EvaluationPlanLevelLabelFields;
